// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3PyAw","footer":"ModalCreateQualiphyProcedure_footer__g5PEM","additionData":"ModalCreateQualiphyProcedure_additionData__DB1Z0"};